export const SEGMENT_LIVE = '1';
export const SEGMENT_DEV = '2';

export const SEGMENT_OPT = [
  {
    text: 'Live',
    value: SEGMENT_LIVE,
  },
  {
    text: 'Development',
    value: SEGMENT_DEV,
  },
];

export const SEGMENT_VALUES = SEGMENT_OPT.map((segment) => segment.value);
